
import React, { useState, useEffect, useRef } from 'react';
import styles from './Billing_panel.module.css';
import { API_BASE_URL, billing_api, Inventory_api } from './../../Apiconfig';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import SearchCustomer from '../Customer/Search customer_billing/Searchcustomer';
import AddCustomerForm from '../Customer/add customer global/Addcustomer';
import SearchInventory from '../Inventory/bill panel search_inventory/search_inventory';
import { showCustomAlert } from '../../customAlert';


const BillingPanel = () => {
  const [billingSections, setBillingSections] = useState([
    {
      id: 1,
      showCustomerForm: false,
      customerType: 'retail',
      customerName: '',
      customerNumber: '',
      orderType: 'direct',
      searchQuery: '',
      showCustomerList: false,
      showProductList: false,
      productSearchQuery: '',
      products: [],
    },
    {
      id: 2,
      showCustomerForm: false,
      customerType: 'retail',
      customerName: '',
      customerNumber: '',
      orderType: 'direct',
      searchQuery: '',
      showCustomerList: false,
      showProductList: false,
      productSearchQuery: '',
      products: [],
    },


  ]);

  const [myIndex, setMyIndex] = useState();


  const [paymentDetails, setPaymentDetails] = useState({
    customerName: '',
    customerNumber: '',
    totalAmount: 0,
    orderId: 0,
    customerId: 0,
    index: 0,
    orderType: '',
  });

  const billingPanelRef = useRef(null);

  // Add a new billing section
  const addBillingSection = () => {
    if (window.innerWidth < 768) {
      showCustomAlert('Adding multiple billing sections is disabled on mobile.');
      return;
    }
    if (billingSections.length < 5) {
      setBillingSections((prev) => {
        const newSections = [
          ...prev,
          {
            id: prev.length + 1,
            showCustomerForm: false,
            customerType: 'retail',
            customerName: '',
            customerNumber: '',
            orderType: 'direct',
            products: [],
            searchQuery: '',
            showCustomerList: false,
            showProductList: false,
            productSearchQuery: '',
          },
        ];

        // Scroll to the right after updating state
        setTimeout(() => {
          if (billingPanelRef.current) {
            billingPanelRef.current.scrollTo({
              left: billingPanelRef.current.scrollWidth,
              behavior: 'smooth',
            });
          }
        }, 0);

        return newSections;
      });
    } else {
      showCustomAlert('You can only have a maximum of 5 billing sections.');
    }
  };

  // Remove a billing section
  const removeBillingSection = (id) => {
    setBillingSections((prev) => prev.filter((section) => section.id !== id));
  };

  const handleCustomerSave = (index, name, number) => {
    const updatedSections = [...billingSections];
    updatedSections[index].customerName = name;
    updatedSections[index].customerNumber = number;
    updatedSections[index].showCustomerForm = false;
    setBillingSections(updatedSections);
  };




  const handleProductSelect = (product, index) => {
    const updatedSections = [...billingSections];
    const existingProduct = updatedSections[index].products.find(
      (p) => p.name === product.product_name
    );

    if (existingProduct) {
      existingProduct.quantity += 1;
      existingProduct.total = existingProduct.price * existingProduct.quantity;
    } else {

      updatedSections[index].products.push({
        name: product.product_name,
        price: Number(product.sale_price),
        quantity: 1,
        total: Number(product.sale_price),
      });
    }

    setBillingSections(updatedSections);
  };


  // Handle editing the product quantity
  const handleEditQuantity = (index, productIndex, newQuantity) => {
    const updatedSections = [...billingSections];
    const product = updatedSections[index].products[productIndex];
    if (!isNaN(newQuantity) && newQuantity > 0) {
      product.quantity = newQuantity;
      product.total = product.price * newQuantity;
      setBillingSections(updatedSections);
    }
  };

  // Handle deleting a product
  const handleDeleteProduct = (index, productIndex) => {
    const updatedSections = [...billingSections];
    updatedSections[index].products.splice(productIndex, 1);
    setBillingSections(updatedSections);
  };

  const handleSelectCustomer = (index, customer) => {
    console.log(customer);
    const updatedSections = [...billingSections];
    if (customer && customer.id && customer.name && customer.contact) {
      updatedSections[index].customerId = customer.id; // Store customer ID
      updatedSections[index].customerName = customer.name;
      updatedSections[index].customerNumber = customer.contact;
      updatedSections[index].showCustomerForm = false;
      setBillingSections(updatedSections);
    } else {
      showCustomAlert('Customer data is invalid or not selected.');
    }
  };


  const handleMakePayment = async (index) => {
    const section = billingSections[index];

    // Check if the section is valid
    if (!section) {
      console.error(`Billing section at index ${index} is undefined.`);
      showCustomAlert('Invalid billing section.');
      return;
    }

    // Check if products are added to the section
    if (!section.products || section.products.length === 0) {
      showCustomAlert('No products added. Please add products to proceed.');
      return;
    }

    // Check if customer is selected
    if (!section.customerId) {
      showCustomAlert('No customer selected. Please select a customer to proceed.');
      return;
    }

    setShowPaymentCard(true);
    const totalAmount = section.products.reduce((acc, product) => acc + product.total, 0) + (section.deliveryCharge || 0);

    const orderData = {
      customer_id: section.customerId,
      customerName: section.customerName,
      total_amount: totalAmount,
      due_amount: totalAmount,
      paid_amount: 0,
      customer_type: section.customerType,
      list_type: section.orderType,
      no_of_items: section.products.length.toString(),
      transaction_id: Math.floor(Math.random() * 1000000),
      transaction_status: 'Pending',
      order_status: 'Pending',
      shipping_address: 'Example Address',
      billing_address: 'Example Address',
      products: section.products.map((product) => ({
        product_name: product.name,
        product_quantity: product.quantity,
        unit_price: product.price,
        total_price: product.total,
      }))
    };
    // console.log(orderData)
    try {
      // Make a POST request to create an order
      const response = await axios.post(`${billing_api}create_bill_order.php`, orderData, {
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data && response.data.success) {
        const { order_id: orderId, customer_id: customerId } = response.data;

        // Update payment details
        setPaymentDetails((prevDetails) => ({
          ...prevDetails,
          customerName: section.customerName,
          customerNumber: section.customerNumber,
          totalAmount: orderData.total_amount,
          orderId: orderId,
          customerId: customerId,
          orderType: section.orderType
        }));


        // console.log('Payment Details:', paymentDetails, paymentDetails.customerId);



      } else {
        showCustomAlert(response.data.message)
      }
    } catch (error) {
      console.error('Error processing payment:', error);
      showCustomAlert('Error processing payment. Please try again later.');
    }
  };


  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [orderStatus, setorderStatus] = useState('');
  const [showPaymentCard, setShowPaymentCard] = useState(false);



  // Handle payment method selection
  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethod(method);
  };

  const handleSubmitPayment = async (orderId, paymentMethod, amount, orderStatus) => {
    if (!paymentMethod || !amount || amount <= 0) {
      showCustomAlert('Please select a valid payment method and amount.');
      return;
    }

    try {
      // Send payment data to the backend API
      const response = await axios.post(`${billing_api}update_payment_status.php`, {
        order_id: orderId,
        payment_method: paymentMethod,
        paid_amount: amount,
        order_status: orderStatus,
        customer_id: paymentDetails.customerId,
      }, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      // console.log(response.data)
      if (response.data.success) {
        showCustomAlert('Payment updated successfully!');
        // setShowPaymentCard(false);
        // setSelectedPaymentMethod("");
        // setPaymentAmount("");
        // setorderStatus("");

        // setBillingSections((prevSections) => prevSections.map((section, i) => {
        //   if (i === myIndex) {
        //     return {
        //       ...section,
        //       customerName: '',
        //       customerNumber: '',
        //       orderType: 'direct', 
        //       products: [],
        //       customerId: 0,
        //       showCustomerForm: false,
        //       showProductList: false,
        //       productSearchQuery: '',
        //     };
        //   }
        //   return section; 
        // }));


        // setPaymentDetails({
        //   customerName: '',
        //   customerNumber: '',
        //   totalAmount: 0,
        //   orderId: 0,
        //   customerId: 0,
        //   index: 0,
        //   orderType: '',
        // });
      } else {
        showCustomAlert('Failed to update payment.');
      }
    } catch (error) {
      console.error('Error updating payment:', error);
      showCustomAlert('Error processing payment. Please try again.');
    }
  };

  // Function to generate the invoice PDF
  const handleGenerateInvoice = (index) => {
    const section = billingSections[index];
    if (!section.customerName || !section.customerNumber) {
      showCustomAlert('Please select a customer before generating the invoice.');
      return;
    }

    if (section.products.length === 0) {
      showCustomAlert('Please add products before generating the invoice.');
      return;
    }

    const doc = new jsPDF();

    // Add Title
    doc.setFontSize(18);
    doc.text('Invoice', 105, 20, null, null, 'center');

    // Add Customer Details
    doc.setFontSize(12);
    doc.text(`Customer Name: ${section.customerName}`, 10, 40);
    doc.text(`Customer Number: ${section.customerNumber}`, 10, 50);
    doc.text(`order_ID: ${paymentDetails.orderId}`, 10, 60);


    // Table Header and Data
    const tableColumnHeaders = ['Product Name', 'Price', 'Quantity', 'Total'];
    const tableRows = section.products.map((product) => [
      product.name,
      product.price.toFixed(2),
      product.quantity,
      product.total.toFixed(2),
    ]);

    // Add Table
    doc.autoTable({
      startY: 70,
      head: [tableColumnHeaders],
      body: tableRows,
    });

    // Add Total Amount
    const totalAmount = section.products.reduce((acc, product) => acc + product.total, 0);
    doc.setFontSize(14);
    doc.text(`Total Amount: ${totalAmount.toFixed(2)}`, 10, doc.lastAutoTable.finalY + 10);

    // Save PDF
    doc.save(`Invoice_${section.customerName}.pdf`);
  };


  // Function to generate the invoice PDF
  const generateDemandListPdf = (index) => {
    const section = billingSections[index];
    if (!section.customerName) {
      showCustomAlert('Please select a customer before generating the invoice.');
      return;
    }

    if (section.products.length === 0) {
      showCustomAlert('Please add products before generating the invoice.');
      return;
    }

    const doc = new jsPDF();

    // Add Title
    doc.setFontSize(18);
    doc.text('Invoice', 105, 20, null, null, 'center');

    // Add Customer Details
    doc.setFontSize(12);
    doc.text(`Customer Name: ${section.customerName}`, 10, 40);
    doc.text(`order_ID: ${paymentDetails.orderId}`, 10, 50);


    const tableColumnHeaders = ['Product Name', , 'Quantity',];
    const tableRows = section.products.map((product) => [
      product.name,
      product.quantity,
    ]);


    doc.autoTable({
      startY: 60,
      head: [tableColumnHeaders],
      body: tableRows,
    });

    doc.save(`demand_list_${section.customerName}.pdf`);
  };


  const handleGenerateInvoiceAndShare = (index) => {
    const section = billingSections[index];
    if (!section.customerName || !section.customerNumber) {
      showCustomAlert('Please select a customer before generating the invoice.');
      return;
    }

    if (section.products.length === 0) {
      showCustomAlert('Please add products before generating the invoice.');
      return;
    }

    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text('Invoice', 105, 20, null, null, 'center');

    doc.setFontSize(12);
    doc.text(`Customer Name: ${section.customerName}`, 10, 40);
    doc.text(`Customer Number: ${section.customerNumber}`, 10, 50);

    const tableColumnHeaders = ['Product Name', 'Price', 'Quantity', 'Total'];
    const tableRows = section.products.map((product) => [
      product.name,
      product.price.toFixed(2),
      product.quantity,
      product.total.toFixed(2),
    ]);

    doc.autoTable({
      startY: 60,
      head: [tableColumnHeaders],
      body: tableRows,
    });

    const totalAmount = section.products.reduce((acc, product) => acc + product.total, 0);
    doc.setFontSize(14);
    doc.text(`Total Amount: ${totalAmount.toFixed(2)}`, 10, doc.lastAutoTable.finalY + 10);


    const pdfBlob = doc.output('blob');

    const pdfUrl = URL.createObjectURL(pdfBlob);

    const whatsappMessage = `Here is your invoice: ${pdfUrl}`;
    const encodedMessage = encodeURIComponent(whatsappMessage);

    const whatsappApiUrl = `https://wa.me/?text=${encodedMessage}`;

    window.open(whatsappApiUrl, '_blank');
  };

 


  return (
    <>
      <div className={`${styles.billingmaincontainer_panel} d-flex`}>

        {/* Add Billing Section Button */}
        <div className={styles.addSection}>
          <button className={styles.addSectionButton} onClick={addBillingSection}>
            Add ++ Billing Section
          </button>
        </div>

        {/* Billing Sections */}
        <div className={styles.billingPanel}
          ref={billingPanelRef} >
          {billingSections.map((section, index) => (
            <div
              key={section.id}
              className={`${styles.billsection} ${window.innerWidth < 768 && index !== 0 ? styles.hiddenSection : ''
                }`}
            >
              {/* Cross Button for Removing Section */}
              {index !== 0 && (
                <button
                  className={styles.removeButtonbillpanel}
                  onClick={() => removeBillingSection(section.id)}
                  title="Remove Section"
                >
                  ✖
                </button>
              )}

              {/* Customer Search Section */}
              <div className={styles.billingpanel_top}>

                <div className={styles.searchSection}>

                  <div className={styles.customerinfo_col}>
                    <SearchCustomer style={{ width: '100%' }} onSelectCustomer={(customer) => handleSelectCustomer(index, customer)} />
                    {section.customerName && section.customerNumber ? (
                      <div className={styles.customerInfo}>
                        <p><strong>Name:</strong> {section.customerName}</p>
                        <p><strong>No:</strong> {section.customerNumber}</p>
                      </div>
                    ) : (
                      <p className={styles.searchcustomer_text}>Search Customer</p>
                    )}
                  </div>
                  <AddCustomerForm />

                </div>
                <SearchInventory onProductSelect={(product) => handleProductSelect(product, index)} />
              </div>






              {/* Product Display Table */}
              <div className={styles.productDisplay}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Price</th>
                      <th>Quantity</th>
                      <th>input QYT</th>
                      <th>DELET</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>

                    {section.products.map((product, productIndex) => (
                      <tr key={productIndex} className={styles.tableinputbill}>
                        <td><strong>{product.name}</strong> </td>
                        <td>Price: {product.price} </td>
                        <td>Quantity: {product.quantity} </td>
                        <td>  <input
                          type="number"
                          value={product.quantity}
                          onChange={(e) =>
                            handleEditQuantity(index, productIndex, Number(e.target.value))
                          }
                          min="1"
                        /></td>
                        <td>

                          <button
                            className={styles.deleteProductButton}
                            onClick={() => handleDeleteProduct(index, productIndex)}
                          >
                            Delete
                          </button>
                        </td>
                        <td> {product.total} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className={styles.billingpanel_top}>

                <div className={styles.totalSection}>

                  <input
                    type="number"
                    placeholder='Delivery charge'
                    value={section.deliveryCharge}
                    onChange={(e) => {
                      const updatedSections = [...billingSections];
                      updatedSections[index].deliveryCharge = parseFloat(e.target.value);
                      setBillingSections(updatedSections);
                    }}
                    className={styles.deliveryInput}
                  />
                  <div className='d-flex'>

                    <button className={styles.calculatorButton}><i className="fa-solid fa-calculator "></i></button>
                    <p className={styles.totalText}>
                      Total Rs. = ₹
                      {section.products.reduce(
                        (acc, product) => acc + product.total,
                        0
                      ) + (section.deliveryCharge || 0)}
                    </p>
                  </div>
                </div>

                {/* Customer Type Selector */}
                <div className={styles.selector}>
                  <select
                    id={`customerType-${section.id}`}
                    value={section.customerType}
                    onChange={(e) => {
                      const updatedSections = [...billingSections];
                      updatedSections[index].customerType = e.target.value;
                      setBillingSections(updatedSections);
                    }}
                    className={styles.dropdownselector}
                  >
                    <option value="" disabled>
                      Select Customer Type
                    </option>
                    <option value="retail">Retail Customer</option>
                    <option value="wholesale">Wholesale Customer</option>
                  </select>
                  <select
                    id={`orderType-${section.id}`}
                    value={section.orderType}
                    onChange={(e) => {
                      const updatedSections = [...billingSections];
                      updatedSections[index].orderType = e.target.value;
                      setBillingSections(updatedSections);
                    }}
                    className={styles.dropdownselector}
                  >
                    <option value="direct">Direct Order</option>
                    <option value="demand">Demand List</option>
                  </select>
                </div>

                {/* Conditional Rendering for Options */}
                {section.orderType === 'direct' && (
                  <div className={styles.buttonContainer}>
                    <button key={index} onClick={() => { handleMakePayment(index); setMyIndex(index) }}>
                      Make Payment for {section.customerName}
                    </button>
                    {/* <button
                    className={styles.generateInvoiceButton}
                    onClick={() => handleGenerateInvoice(index)}
                  >
                    Generate Invoice
                  </button>
                  <button
                    onClick={() => handleGenerateInvoiceAndShare(index)}>Share Invoice</button> */}
                  </div>
                )}

                {section.orderType === 'demand' && (
                  <div className={styles.buttonContainer}>
                    {/* <button key={index} onClick={() => generateDemandListPdf(index)} >Demand List</button> */}
                    <button key={index} onClick={() => { handleMakePayment(index); setMyIndex(index) }}>
                      Place order for {section.customerName}
                    </button>
                    {/* <button
                    className={styles.generateInvoiceButton}
                    onClick={() => {handleGenerateInvoice(index); console.log("OUT: " + index); setMyIndex(index)}}
                  >
                    Generate Invoice
                  </button>
                  <button
                    onClick={() => handleGenerateInvoiceAndShare(index)}>Share Invoice</button> */}
                  </div>
                )}
              </div>
            </div>


          ))}





        </div>
        {/* Payment Card Modal */}
        {showPaymentCard && (
          <>
            <div className={styles.overlaymakepayment}></div>
            <div className={styles.paymentCard}>
              <div className={styles.paymentCardContent}>
                <h3>Payment Details</h3>
                <p><strong>Customer Name:</strong> {paymentDetails.customerName}</p>
                <p><strong>Customer Number:</strong> {paymentDetails.customerNumber}</p>
                <p><strong>Total Amount:</strong> ₹{paymentDetails.totalAmount}</p>

                {/* Payment Method Selection */}
                <div className={styles.paymentMethods}>
                  <button
                    onClick={() => handlePaymentMethodSelect('Cash')}
                    className={`${styles.paymentButton} ${selectedPaymentMethod === 'Cash' ? styles.active : ''
                      }`}
                  >
                    {selectedPaymentMethod === 'Cash' && (
                      <i className="fa-solid fa-check" style={{ marginRight: '8px' }}></i>
                    )}
                    Cash
                  </button>
                  <button
                    onClick={() => handlePaymentMethodSelect('UPI')}
                    className={`${styles.paymentButton} ${selectedPaymentMethod === 'UPI' ? styles.active : ''
                      }`}
                  >
                    {selectedPaymentMethod === 'UPI' && (
                      <i className="fa-solid fa-check" style={{ marginRight: '8px' }}></i>
                    )}
                    UPI
                  </button>
                </div>
                {/* Payment Amount Input */}
                <div className={styles.paymentAmount}>
                  <label htmlFor="paymentAmount"><strong>Enter Payment Amount:</strong></label>
                  <input
                    id="paymentAmount"
                    type="number"
                    value={paymentAmount}
                    onChange={(e) => setPaymentAmount(e.target.value)}
                    placeholder="Enter amount"
                  />
                </div>

                {/* Order Status Selection */}
                <div className={styles.orderStatus}>
                  <label htmlFor="orderStatus"><strong>Select Order Status:</strong></label>
                  <select
                    id="orderStatus"
                    value={orderStatus}
                    onChange={(e) => setorderStatus(e.target.value)}
                    className={styles.orderStatusDropdown}
                  >
                    <option value="" disabled>Select Status</option>
                    <option value="Pending">Pending</option>

                    <option value="Delivered">Delivered</option>
                    <option value="Canceled">Canceled</option>
                  </select>
                </div>


                {/* Submit Button */}
                <div className={styles.submitButtonContainer}>
                  <button
                    onClick={() => handleSubmitPayment(paymentDetails.orderId, selectedPaymentMethod, paymentAmount, orderStatus)}
                    className={styles.submitButton}
                    disabled={!paymentAmount || !selectedPaymentMethod}
                  >
                    Submit Payment
                  </button>


                </div>
                {paymentDetails.orderType === 'direct' && (
                  <div className={styles.buttonContainer}>
                    <button
                      className={styles.generateInvoiceButton}
                      onClick={() => handleGenerateInvoice(myIndex)}
                    >
                      Generate Invoice
                    </button>
                    <button
                      onClick={() => handleGenerateInvoiceAndShare(myIndex)}>Share Invoice</button>
                  </div>
                )}
                {paymentDetails.orderType === 'demand' && (
                  <div className={styles.buttonContainer}>
                    <button onClick={() => generateDemandListPdf(myIndex)} >Demand List</button>
                    <button
                      className={styles.generateInvoiceButton}
                      onClick={() => handleGenerateInvoice(myIndex)}
                    >
                      Generate Invoice
                    </button>
                    <button
                      onClick={() => handleGenerateInvoiceAndShare(myIndex)}>Share Invoice</button>
                  </div>
                )}

                {/* Close Button */}
                <button
                  onClick={() => {
                    setShowPaymentCard(false); // Hide the payment card
                    setSelectedPaymentMethod(""); // Clear selected payment method
                    setPaymentAmount(""); // Clear payment amount
                    setorderStatus(""); // Clear order status

                    // Reset billing sections
                    setBillingSections((prevSections) =>
                      prevSections.map((section, i) => {
                        if (i === myIndex) {
                          return {
                            ...section,
                            customerName: '',
                            customerNumber: '',
                            orderType: 'direct', // Reset the order type if needed
                            products: [],
                            customerId: 0,
                            showCustomerForm: false,
                            showProductList: false,
                            productSearchQuery: '',
                          };
                        }
                        return section; // Return the unchanged sections
                      })
                    );

                    // Reset the payment details state
                    setPaymentDetails({
                      customerName: '',
                      customerNumber: '',
                      totalAmount: 0,
                      orderId: 0,
                      customerId: 0,
                      index: 0,
                      orderType: '',
                    });
                  }}
                  className={styles.closeButton}
                >
                  Close
                </button>

              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BillingPanel;
